import Vue from 'vue';
import emojiStrip from 'emoji-strip';

// https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way
function event (name) {
  var evt = document.createEvent('Event');
  evt.initEvent(name, true, true);
  return evt;
}

Vue.directive('blockemojis', (el, binding) => {
  if (binding.value === false) {
    return;
  }

  el.onblur = function (evt) {
    if (!evt.isTrusted) {
      return; // Avoid infinite loop
    }

    // Remove emojis
    el.value = el.value.replace(/([\u2580-\u27BF]|[\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');

    el.value = emojiStrip(el.value);

    // Notify all changes
    el.dispatchEvent(event('input'));
  }

  el.keyup = function (evt) {
    if (!evt.isTrusted) {
      return; // Avoid infinite loop
    }

    // Remove emoji
    el.value = el.value.replace(/([\u2580-\u27BF]|[\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');

    el.value = emojiStrip(el.value);

    // Notify all changes
    el.dispatchEvent(event('input'));
  }
});
